import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Inventory from './components/Inventory';
import TableLoader from '../../components/TableLoader';
import { fetchStaticGraphs } from '../../services/killshot';

const selector = inventory =>
  inventory.map(listingEntry => ({
    skybox_listing_id: listingEntry.skybox_id,
    section: listingEntry.section,
    rows: listingEntry.rows.join(', '),
    quantity: listingEntry.quantity,
    unit_cost: `$${listingEntry.cost.per_unit}`,
    cost_per_unit: listingEntry.cost.per_unit,
    tags: listingEntry.tags.join(', '),
    org_name: listingEntry.org_name,
    listing_detail: [
      {
        seats: `${listingEntry.seats.low} - ${listingEntry.seats.high}`,
        public_notes: listingEntry.notes.public,
        internal_notes: listingEntry.notes.internal,
        tags: listingEntry.tags.join(', '),
      },
    ],
    public_notes: listingEntry.notes.public,
    held: listingEntry.held,
    hold: listingEntry.hold,
    seats: `${listingEntry.seats.low} - ${listingEntry.seats.high}`,
    deliveryMethod: listingEntry.delivery_method,
    qcStatus: !!listingEntry.tags.find(t => t === 'qc'),
    list_price: listingEntry.list_price,
  }));

const styles = theme => ({
  pricingLoadingModalPaper: {
    position: 'absolute',
    width: theme.spacing(50),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
  },
});

const InventoryContainer = props => {
  const { eventId, inventory, skyboxId, eventMeta, loadingInventory } = props;
  const isPricingLoading = loadingInventory;
  const history = useHistory();
  const [staticGraphs, setStaticGraphs] = useState({
    url: '',
  });
  const [isLoading, setLoading] = useState(true);

  const callbackSingleStatic = async () => {
    try {
      // const response = await fetchInventory();
      const graphResponse = await fetchStaticGraphs(eventId);

      // setInventory(response.response);
      setStaticGraphs(graphResponse.response);
      setLoading(false);
    } catch (e) {
      // setError(e);
    }
  };

  const fetchData = async () => {
    try {
      // const response = await fetchInventory();
      const graphResponse = await fetchStaticGraphs(eventId);

      // setInventory(response.response);
      setStaticGraphs(graphResponse.response);
      setLoading(false);
    } catch (e) {
      // setError(e);
    }
  };

  const useFetch = () => {
    useEffect(() => {
      fetchData();
    }, []);
  };

  useFetch();

  useEffect(() => {
    fetchData();
  }, [history.location.pathname]);

  useEffect(() => {}, [inventory]);

  if (isLoading || isPricingLoading) {
    return <TableLoader />;
  }

  return (
    <Inventory
      eventId={eventId}
      eventMeta={eventMeta}
      staticGraphs={staticGraphs}
      inventoryRows={selector(inventory)}
      skyboxId={skyboxId}
      callbackSingleStatic={callbackSingleStatic}
    />
  );
};

InventoryContainer.propTypes = {
  eventId: PropTypes.any.isRequired,
  eventMeta: PropTypes.object.isRequired,
  skyboxId: PropTypes.any.isRequired,
  inventory: PropTypes.array.isRequired,
  loadingInventory: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    eventMeta: state.pricing.eventMeta,
    inventory: state.refreshGroupsInventory.inventory,
    loadingInventory: state.refreshGroupsInventory.loadingInventory,
  };
}

export default connect(mapStateToProps, null)(withStyles(styles)(InventoryContainer));
